export interface DocumentMetadata {
    title: string;
    description: string;
    keywords: string;
}

export const documentConstants: { [s: string]: DocumentMetadata } = {
    LANDING: {
        title: '0x: Powering the decentralized exchange of tokens on Ethereum',
        description:
            '0x is an open protocol that enables the peer-to-peer exchange of assets on the Ethereum blockchain.',
        keywords: '',
    },
    EXPLORE: {
        title: '0x Explore: Trade on 0x Relayers',
        description: 'Check out the wide range of projects and businesses building in the 0x ecosystem!',
        keywords: '',
    },
    API: {
        title: '0x API: Access all DEX liquidity in one place',
        description: 'A single developer endpoint to source an aggregation of liquidity',
        keywords:
            'aggregated liquidity, DeFi liquidity, DEX, Decentralized Exchange, Ethereum, 0x, 0x Protocol, Tokens, ZRX, Crypto Exchange, Cryptocurrency, Crypto, DeFi, Decentralized Finance, crypto trading, token swaps, swap tokens, swap crypto, fill orders, networked liquidity, contract-fillable liquidity, CFL, atomic arbitrage, arbitrage bots, algo trading',
    },
    ZRX_PORTAL: {
        title: 'ZRX Portal: Stake and vote with your ZRX tokens',
        description: 'Earn liquidity rewards by staking ZRX',
        keywords:
            'DEX, Decentralized Exchange, Ethereum, 0x, 0x Protocol, ZRX, token staking, ZRX token, ZRX price, ZRX staking, ZRX voting, 0x governance, Crypto Exchange, Cryptocurrency, Crypto, DeFi, Decentralized Finance, Open Finance, Crypto Market Maker, Networked Liquidity, 0x Home, staking dashboard',
    },
    WHY: {
        title: '0x: Features and Benefits',
        description:
            '0x Protocol is free, open-source infrastructure that developers and businesses utilize to build products that enable the purchasing and trading of crypto tokens.',
        keywords: '',
    },
    INSTANT: {
        title: '0x Instant: Quick and secure crypto purchasing',
        description: 'A free and flexible way to offer simple crypto purchasing in any app or website.',
        keywords: '',
    },
    LAUNCH_KIT: {
        title: '0x Launch Kit: Launch your own exchange or marketplace in minutes',
        description:
            'Launch Kit includes a set of tools, UI and documentation to build an exchange or marketplace in minutes on 0x.',
        keywords: '',
    },
    ABOUT: {
        title: '0x: Our Mission and Values',
        description:
            'As more assets become tokenized, 0x provides the critical exchange layer in a new financial stack that is more efficient, transparent, and equitable than any system in the past.',
        keywords: '',
    },
    PRESS: {
        title: '0x: Press Highlights',
        description: '0x has been featured in major publications such as Forbes, Fortune, VentureBeat, and TechCrunch.',
        keywords: '',
    },
    JOBS: {
        title: 'Jobs at 0x',
        description:
            'Join us in building infrastructure upon which the exchange of all tokenized assets will take place.',
        keywords: '',
    },
    ECOSYSTEM_PROGRAM: {
        title: '0x Ecosystem Acceleration Program: Jumpstart your Business on 0x',
        description:
            'The Ecosystem Acceleration Program gives teams access to a variety of services including funding, dedicated technical support, and recruiting assistance.',
        keywords: '',
    },
    MARKET_MAKER_PROGRAM: {
        title: '0x Market Maker Program: Bring liquidity to the markets of the future',
        description:
            'The Market Making Program provides a set of resources that help onboard MMs to bring liquidity to the 0x network. The Program includes tutorials, monetary incentives, and 1:1 support from the 0x team.',
        keywords: '',
    },
    INFRASTRUCTURE_CREDITS: {
        title: '0x Infrastructure Credits: Earn credits for your business on 0x',
        description:
            '0x has teamed up with a variety of service providers to offer free credits for any project working on 0x in a full-time capacity.',
        keywords: '',
    },
    DOCS: {
        title: '0x Documentation',
        description:
            '0x Protocol is free, open-source infrastructure that developers and businesses utilize to build products that enable the purchasing and trading of crypto tokens.',
        keywords: '',
    },
    STAKING: {
        title: '0x Staking',
        description:
            '0x Protocol is free, open-source infrastructure that developers and businesses utilize to build products that enable the purchasing and trading of crypto tokens.',
        keywords: '',
    },
    VOTE: {
        title: '0x Governance: Vote on ZEIPs with ZRX',
        description:
            '0x is an open protocol that is governed by its users. Cast your votes with ZRX on 0x Improvement Proposals.',
        keywords: '',
    },
    EXTENSIONS: {
        title: '0x Extensions',
        description: 'Support new types of trading on your relayer with 0x Extensions',
        keywords: '',
    },
    PRIVACY_POLICY: {
        title: '0x: Privacy Notice & Cookie Notice',
        description: '',
        keywords: '',
    },
    TERMS_OF_SERVICE: {
        title: '0x: Terms of Service',
        description: '',
        keywords: '',
    },
    CFL: {
        title: '0x Asset Swapper: Programmatically swap tokens via smart contracts',
        description: 'Bring automatic token trading to your DeFi users with Asset Swapper',
        keywords: '',
    },
    MESH: {
        title: '0x Mesh: Access peer-to-peer token markets',
        description:
            'Use 0x Mesh to access a global peer-to-peer orderbook for tokens. Decentralized, it supports any type of assets including NFTs.',
        keywords:
            'liquidity, DeFi, DEX, Decentralized Exchange, Ethereum, 0x, 0x Protocol, Tokens, ZRX, Crypto Exchange, Cryptocurrency, Crypto, DeFi, Decentralized Finance, crypto trading, token swaps, swap tokens, swap crypto, fill orders, networked liquidity, contract-fillable liquidity, CFL, atomic arbitrage, arbitrage bots, algo trading',
    },
};
